<script setup lang="ts">
import type { MaxBid } from "mws-ts-v2-sdk";

type Props = {
  activeMaxBid: MaxBid;
};

const { activeMaxBid } = defineProps<Props>();

const { amount: maxBidAmount } = usePrice(() => activeMaxBid?.prices ?? []);
</script>

<template>
  <div>
    <I18nT
      scope="global"
      keypath="product.bidAmount.yourActiveMaxBid"
      class="uppercase inline font-bold text-sm"
      tag="p"
    >
      <template #PLACEHOLDER_amount>
        <BaseCurrency
          :iso="maxBidAmount.currencyCode"
          :value="maxBidAmount.value"
        />
      </template>
    </I18nT>
  </div>
</template>
